<template>
  <!-- 信息公开制度 -->
  <div class="box index-less">
    <details-head img="./img/bj3.png" title="信息公开制度" remarks="PublicitySystem" />
    <TopBreadcrumb :data="[{ label: '规划协会' }, { label: '信息公开制度' }]" />
    <div class="con">
      <!-- <TopTab/> -->
      <div class="box">

        <div class="left">
          <Left title="信息公开制度" remarks="Information disclosure system"/>
        </div>
        <div class="right">
          <right-item  title="第一条" context="讲诚实，守信用，作为中国的传统文化一直被社会所认同和遵守。作为以技术和知识服务于社会的勘察设计行业，讲科学、讲诚信更是行业的立业之本。勘察设计工作是城市建设和工程建设的先导，做好勘察设计工作必须坚持科学发展观、坚持诚信服务的宗旨。" />
          <right-item  title="第二条" context="本制度所称信息公开是指将可能对本行业产生重大影响而会员尚未得知的信息，在规定的时间内，以规定的方式向会员或社会公布的行为。" />
          <right-item  title="第三条" context="本会信息披露的内容包括定期报告和临时报告。年度报告为定期报告，其他报告为临时报告。社团登记管理机关认为有必要披露的信息，也应当予以披露。" />
        </div>
        <!-- <Right title="信息公开制度" context="规范本会的信息披露工作，确保信息披露的真实、准确、完整、及时、公平，促进本会规范运作，维护会员的合法权益，制定本制度。" /> -->
      </div>
    </div>
  </div>
</template>

<script>
import DetailsHead from "@/components/DetailsHead.vue";
import TopBreadcrumb from "@/components/TopBreadcrumb.vue";
import Left from "./comp/Left.vue";
import Right from "./comp/Right.vue";
import TopTab from "./comp/TopTab.vue";
import './comp/index.less'
import RightItem from "./comp/RightItem.vue";
export default {
  components: { DetailsHead, TopBreadcrumb, Left, Right,TopTab,RightItem },
  data() {
    return {};
  },
  methods: {},
};
</script>
 
<style lang="less" scoped>
.con .box .right {
  display: flex;
  flex-direction: column;
  gap: 13px;
}
</style>